import { Icon, Typography } from 'src/modules/core/components'
import { BookingLogo } from '../booking-logo'
import type { BookingStepHeaderProps } from './booking-step-header.interface'
import classes from './booking-step-header.module.scss'

export function BookingStepHeader({ providerName, logoUrl, activeStep }: BookingStepHeaderProps) {
  const step1Active = activeStep === 1
  const step2Active = activeStep === 2

  return (
    <div className={classes.header}>
      <BookingLogo
        logoUrl={logoUrl}
        alt={providerName}
        className={classes.headerLogo}
        fallback={
          <div className={classes.headerIcon}>
            <Icon name="calendarAlt" />
          </div>
        }
      />
      <Typography variant="h1" className={classes.title}>
        Book with {providerName}
      </Typography>
      <Typography variant="body" className={classes.subtitle}>
        Schedule your appointment in just a few steps
      </Typography>
      <div className={classes.stepper}>
        <div className={classes.step}>
          <div className={step1Active ? classes.stepCircleActive : classes.stepCircle}>
            <Typography variant="body" className={classes.stepNumber}>
              1
            </Typography>
          </div>
          <Typography variant="body" className={step1Active ? classes.stepLabelActive : classes.stepLabel}>
            Date & Time
          </Typography>
          <div className={`${classes.stepLine} ${step1Active ? classes.stepLineActive : ''}`} />
        </div>
        <div className={classes.step}>
          <div className={step2Active ? classes.stepCircleActive : classes.stepCircle}>
            <Typography variant="body" className={classes.stepNumber}>
              2
            </Typography>
          </div>
          <Typography variant="body" className={step2Active ? classes.stepLabelActive : classes.stepLabel}>
            Details
          </Typography>
        </div>
      </div>
    </div>
  )
}
